export default __webpack_public_path__ + "static/logo-4c5bf2f11869d464cdf162b61193b373.jpg";